import { useMutation } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';

import { emailSubscriptionStatusFn } from './api';
import { useUpdatePatientInfoCache } from '../patient/use-update-patient-info-cache';

interface Props {
  patientGuid: string;
  onSuccess: () => void;
}
interface DataProps {
  reason: string;
}

export const useEmailSubscriptionStatus = ({
  patientGuid,
  onSuccess,
}: Props) => {
  const { updateCache } = useUpdatePatientInfoCache();

  const { mutate, isLoading } = useMutation({
    mutationFn: async ({ reason }: DataProps) =>
      emailSubscriptionStatusFn({ reason, patientGuid }),
    onSuccess(data) {
      updateCache(patientGuid, {
        emailSubscription: data.subscription,
      });
      onSuccess();
      notificationController.success({
        message: 'Patient has been resubscribed to emails',
      });
    },
  });

  return {
    updateSubscriptionStatus: mutate,
    subscriptionStatusLoading: isLoading,
  };
};
